import type { TFunction } from "i18next";

/**
 * Translates an integration display name when it is a translation key (e.g. "integrations.names.adzuna").
 * Returns the translated string if the key exists, otherwise the raw value.
 */
export function translateIntegrationDisplayName(
  displayName: string | null | undefined,
  t: TFunction,
  i18n: { exists: (key: string) => boolean }
): string {
  if (!displayName) return "";
  return i18n.exists(displayName) ? t(displayName) : displayName;
}
